import React from "react"
import { storyblokEditable } from "@storyblok/react"

import { useStaticQuery, graphql } from "gatsby"
import { getImage } from "gatsby-plugin-image"

import { LocationTeaser } from "gatsby-theme-gba"

const LocationTeaserEditable = ({ blok }) => {
  const { file, allFile } = useStaticQuery(graphql`
    query LocationTeaserExampleQuery {
      file(relativePath: { eq: "location-teaser.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      allFile(filter: { id: { regex: "/(?:.*)locationTeaser/" } }) {
        edges {
          node {
            id
            name
            childImageSharp {
              gatsbyImageData(quality: 80, layout: FULL_WIDTH)
            }
          }
        }
      }
    }
  `)

  const filteredFiles = allFile.edges.filter(
    (projectFile) =>
      blok.image && projectFile.node.id.includes(blok.image.substring(1))
  )

  const imageFile = filteredFiles[0]
    ? getImage(filteredFiles[0].node)
    : blok.image

  const link =
    blok.link.url || blok.link.cached_url
      ? blok.link.linktype === "story"
        ? blok.link.id
        : blok.link.url
      : "/home"

  const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  }

  const replaceAll = (str, term, replacement) =>
    str.replace(new RegExp(escapeRegExp(term), "g"), replacement)

  return (
    <div {...storyblokEditable(blok)} key={blok._uid}>
      <LocationTeaser
        headline={blok.headline || "Headline"}
        infoHeadline={blok.infoHeadline || "Info Headline"}
        infoSubHeadline={blok.infoSubHeadline}
        link={link}
        linkText={blok.linkText}
        image={imageFile || file.childImageSharp.gatsbyImageData}
        imageAlt={blok.imageAlt}
        mode={blok.mode}
        currentLanguage={blok.currentLanguage}
      >
        {replaceAll(blok.body, "\u2028", "")}
      </LocationTeaser>
    </div>
  )
}

export default LocationTeaserEditable
